// import Cookies from 'universal-cookie';
import axios from 'axios';

// export function getGlid(){
//     const cookie = new Cookies();

//     var glid = '';

//     let visitorData = cookie.get('loginCookkie');
//     if (visitorData) {
//         visitorData = visitorData.split("|");

//         let sd = [];
//         visitorData.map((data) => {
//             sd = data.split("=")
//             if (sd[0] == "glid") {
//                 glid = sd[1]
//             }
//         })
//     }
//     return glid;
// }

export async function writeAddInfo(gst, udyam, bisAdd, bisPin, bisOwn, resAdd, resPin, resOwn, glid, ak) {
    let host = window.location.hostname;

    if (udyam == "") {
        udyam = "NA";
    }

    let apiURL = host === 'www.hellotrade.com'
        ? "https://www.hellotrade.com/api/v1/addInfo"
        : "https://dev.hellotrade.com/api/v1/addInfo";

    let inputData = {
        glid: glid,
        udhyam: udyam,
        gst: gst,
        bisAdd: bisAdd,
        bissPin: bisPin,
        bissOwn: bisOwn,
        resAdd: resAdd,
        resPin: resPin,
        resOwn: resOwn,
        ak:ak
    };

    let formData = new FormData();
    for (let key in inputData) {
        formData.append(key, inputData[key]);
    }

    try {
        const response = await axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: apiURL,
            data: formData,
            timeout: 2000,
        });

        if (response.data.CODE === "200" && response.data.MESSAGE === 'SUCCESS') {
            console.log("Success response:", response);
            return "success";
        } else {
            console.log("Error response:", response);
            return "error";
        }
    } catch (error) {
        console.error("Error in writing additional info:", error);
        return "error";
    }
}


// export function setUserSession(glid, gst, bisAdd, bisPin){
//     const userInfo = {
//         glid,
//         gst,
//         bisAdd,
//         bisPin
//     };

//     sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
// }

// export function getUserSession() {
//     const userInfoString = sessionStorage.getItem('userInfo');
//     if (userInfoString) {
//         const userInfo = JSON.parse(userInfoString);
//         return userInfo;
//     } else {
//         console.log('No userInfo found in session storage.');
//         return "";
//     }
// }

export const banks = [
    "Bank of Baroda",
    "Bank of India",
    "Bank of Maharashtra",
    "Canara Bank",
    "Central Bank of India",
    "Indian Bank",
    "Indian Overseas Bank",
    "Punjab National Bank",
    "Punjab & Sind Bank",
    "State Bank of India",
    "Union Bank of India",
    "UCO Bank",
    "Axis Bank Ltd.",
    "Bandhan Bank Ltd.",
    "CSB Bank Ltd.",
    "City Union Bank Ltd.",
    "DCB Bank Ltd.",
    "Dhanlaxmi Bank Ltd",
    "Federal Bank Ltd.",
    "HDFC Bank Ltd",
    "ICICI Bank Ltd.",
    "Induslnd Bank Ltd",
    "IDFC First Bank Ltd",
    "Jammu & Kashmir Bank Ltd.",
    "Karnataka Bank Ltd.",
    "Karur Vysya Bank Ltd",
    "Kotak Mahindra Bank Ltd.",
    "Lakshmi Vilas Bank Ltd",
    "Nainital Bank Ltd.",
    "RBL Bank Ltd.",
    "South Indian Bank Ltd.",
    "Tamilnad Mercantile Bank Ltd.",
    "YES Bank Ltd.",
    "IDBI Bank Ltd.",
    "DBS Bank",
    "State Bank of Mauritius",
    // "Australia & New Zealand Banking Group",
    "Bank of Bahrain and Kuwait",
    "AB Bank",
    "Sonali Bank",
    "Bank of Nova Scotia",
    "Bank of China",
    // "Industrial & Commercial Bank of China",
    "Danske Bank",
    "Saxo Bank",
    "Barclays",
    "HSBC Bank India",
    "Standard Chartered India",
    "BNP Paribas",
    "Société Générale",
    // "Crédit Agricole Corporate and Investment Bank",
    "Deutsche Bank",
    "Bank Maybank Indonesia",
    "Mizuho Corporate Bank",
    "MUFG Bank",
    // "Sumitomo Mitsui Banking Corporation",
    "ABN AMRO",
    "Rabobank",
    "Doha Bank",
    "Qatar National Bank",
    "Sberbank",
    "NatWest Group",
    "United Overseas Bank",
    "FirstRand Bank",
    "Industrial Bank of Korea",
    "KEB Hana Bank",
    "Kookmin Bank",
    "Shinhan Bank",
    "Woori Bank",
    "Bank of Ceylon",
    "Handelsbanken",
    "Credit Suisse",
    "CTBC Bank",
    "Krung Thai Bank",
    "Abu Dhabi Commercial Bank",
    "Emirates NBD",
    "First Abu Dhabi Bank",
    "American Express",
    "Bank of America",
    "JPMorgan Chase",
    "Other"
];

export async function writeLogs (glid, input, output, status, serviceName, code, issue, reqTime, respTime, totalTime) {
    // const payload = { glid, input, output, status, serviceName, code, issue, reqTime, respTime, totalTime };
    let host = window.location.hostname;
    const url = host === "www.hellotrade.com" ? 
    "https://loans.indiamart.com/api/v1/setLogs" : 
    "https://dev-loans.indiamart.com/api/v1/setLogs";
  
    const formData = new URLSearchParams();

  formData.append("glid", glid);
  formData.append("input", input);
  formData.append("output", output);
  formData.append("status", status);
  formData.append("serviceName", serviceName);
  formData.append("code", code);
  formData.append("issue", issue);
  formData.append("reqTime", reqTime);
  formData.append("respTime", respTime);
  formData.append("totalTime", totalTime);

  try {
    const response = await axios.post(url, formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });

    console.log("Response from SetLogs API =>", response.data);
    return response.data;
  } catch (error) {
    console.error("Error from SetLogs API =>", error.response?.data || error.message);
    return { error: error.response?.data || error.message };
  }
  };

export function gatrack(category, action, label, value = null) {
    
    if (!window.dataLayer) {
        console.error("GTM Data Layer not found!");
        return;
    }
    // console.log("window imgtm => ", window.imgtm);
    // console.log("window layer => ", window.dataLayer);

    window.dataLayer.push({ 'event': 'IMEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label, 'eventValue': value });

}

export function getCurrentIST() {
    const options = { timeZone: "Asia/Kolkata", hour12: false };
    return new Date().toLocaleString("en-US", options);
  }


  export function openFinagg(link) {
    //console.log("link number =>", link);
   

    if(link != ""){
        window.location.href = link;
    } else{
        alert("Please enter a valid link");
    }
    
}

